import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import axios from "../lib/axios";

const NewspaperDetails = () => {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    size: "",
    date: "",
    phone: "",
  });
  const [data, setData] = useState(null);

  const categories = [
    {
      id: "classified-text",
      name: "Classified Text Ad",
      icon: (
        <svg
          className="w-16 h-16 mb-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      ),
    },
    {
      id: "classified-display",
      name: "Classified Display Ad",
      icon: (
        <svg
          className="w-16 h-16 mb-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
          />
        </svg>
      ),
    },
    {
      id: "display",
      name: "Display Ad",
      icon: (
        <svg
          className="w-16 h-16 mb-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      ),
    },
    {
      id: "death-text",
      name: "Death Text Ad",
      icon: (
        <svg
          className="w-16 h-16 mb-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M19 4h-1a1 1 0 00-1 1v1H7V5a1 1 0 00-1-1H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm-6 12h-2m-1-4h4"
          />
        </svg>
      ),
    },
    {
      id: "death-display",
      name: "Death Display Ad",
      icon: (
        <svg
          className="w-16 h-16 mb-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M19 4h-1a1 1 0 00-1 1v1H7V5a1 1 0 00-1-1H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm-6 8a2 2 0 100-4 2 2 0 000 4zm-3 4h6"
          />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    axios.get(`/api/newspaper-ads/${id}`).then((res) => {
      setData(res.data);
    });
  }, [id]);

  const handleBookAd = (categoryId) => {
    setSelectedCategory(categoryId);
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if selected date is tomorrow
    const selectedDate = new Date(formData.date);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Check if current time is after 4 PM
    const currentHour = new Date().getHours();

    if (
      selectedDate.toDateString() === tomorrow.toDateString() &&
      currentHour >= 16
    ) {
      toast.error(
        "OH NOO! You are late... Please select a different date as booking for tomorrow is closed after 4 PM."
      );
      return;
    }

    // Process form submission
    console.log("Form submitted:", { ...formData, option: selectedCategory });
    const response = await axios.post(`/api/newspaper-ads/${id}/book`, {
      ...formData,
      option: selectedCategory,
    });
    if (response.status === 200) {
      toast.success("Ad booking request submitted successfully!");
      setShowModal(false);

      setFormData({
        name: "",
        email: "",
        size: "",
        date: "",
      });
    } else {
      toast.error("Something went wrong!");
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <div className="flex flex-col md:flex-row gap-8 bg-white p-4 rounded-lg shadow-sm">
              <div className="w-full md:w-1/3">
                <img
                  src={
                    data?.image?.url
                      ? `${data.image.url}`
                      : "https://via.placeholder.com/400"
                  }
                  alt={data?.publication_name}
                  className="w-full h-[200px] object-cover rounded-lg shadow-md"
                />
              </div>
              <div className="w-full md:w-2/3">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  {data?.publication_name}
                </h1>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="text-gray-600 w-24">Language:</span>
                    <span className="font-medium capitalize">
                      {data?.language}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-gray-600 w-24">Coverage:</span>
                    <span className="font-medium capitalize">
                      {data?.coverage}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-gray-600 w-24">Readers:</span>
                    <span className="font-medium">
                      {data?.total_readers?.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                Newspaper Advertisement
              </h1>
              <p className="mt-2 text-sm text-gray-600">
                Choose from our various advertisement categories
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((category) => (
              <div
                key={category.id}
                className="bg-white rounded-lg shadow-sm p-6 flex flex-col items-center text-center hover:shadow-md transition-shadow"
              >
                <div className="text-gray-600">{category.icon}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  {category.name}
                </h3>
                <button
                  onClick={() => handleBookAd(category.id)}
                  className="mt-auto bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
                >
                  Book Ad
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Booking Modal */}
      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        className="modal-dialog-centered"
      >
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h4 className="text-xl font-semibold text-gray-900">
              Book Advertisement
            </h4>
            <button
              onClick={() => setShowModal(false)}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FaTimes />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Phone
                </label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Size
                </label>
                <select
                  name="size"
                  value={formData.size}
                  onChange={handleInputChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                >
                  <option value="">Select size</option>
                  <option value="quarter">Quarter Page</option>
                  <option value="half">Half Page</option>
                  <option value="full">Full Page</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Publication Date
                </label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split("T")[0]}
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Footer />
    </>
  );
};

export default NewspaperDetails;
